import { compact, filter, find, flatten, includes, map } from 'lodash'

import { ManagerDetailFragment, ManagerOverviewFragment } from "@docpace/shared-graphql/fragments"

interface HasManagerPermissionsIdInterface {
    departmentId: string
    providerId: string
}

export function hasManagerPermission(
    { departmentId, providerId }: HasManagerPermissionsIdInterface, 
    manager: ManagerDetailFragment
){
    if(!manager) return false
    const permission = find(manager?.managerProviderPermissions?.nodes, {
        departmentId: null,
        providerId
    }) ?? find(manager?.managerProviderPermissions?.nodes, {
        departmentId,
        providerId
    })
    return !!permission
}

export function findTableauManagersInManagers (managers: ManagerOverviewFragment[]): ManagerOverviewFragment[] {
    const tableauManagerIds = compact(filter(map(managers, 'tableauManagerId'), (a)=>!!a))
    return managers?.filter(({ managerId })=>includes(tableauManagerIds, managerId))
}

export function findProviderIdsInManagers(managers: ManagerOverviewFragment[]){
    const providerDepartmentPermissions = flatten(map(
        managers, 
        ({ managerProviderPermissions })=>managerProviderPermissions.nodes
    ))
    return compact(map(providerDepartmentPermissions, 'providerId'))
}
